import React from "react";
import { Link } from "react-router-dom";
import strings from "../Language";
import { images } from "../../config/image";
import api from "../../config/api";
import { getUserData, storeUserData } from "../Util";

class Header extends React.Component {
    constructor(props) {
        super(props);
        var headerData = (this.props && this.props.data) ? this.props.data : {};
        var headerTitle = (this.props && this.props.data && this.props.data.title) ? this.props.data.title : "";
        this.state = {
            lang: strings.getLanguage(),
            headerData: headerData,
            headerTitle: headerTitle,
            access_token: null,
            notify: 0,
        }
    }

    async componentDidMount() {
        window.scrollTo(0, 0);

        var headerTitle = (this.state.headerTitle && this.state.headerTitle != '') ? " | " + this.state.headerTitle : "";
        document.title = "AKLighting" + headerTitle;

        const user_token = await localStorage.getItem('user_token');
        this.setState({ access_token: user_token });

        if (user_token) {
            await storeUserData(user_token, this);
            setTimeout(() => {
                var userData = getUserData();
                if (userData && userData.data && userData.data.notify) {
                    this.setState({ notify: userData.data.notify });
                }
            });

        }
    }

    /**
     * Change Language
     * @param {string} obj 
     */
    changeLanguage(lang) {
        if (lang) {
            strings.setLanguage(lang);
            localStorage.setItem("language", lang);
            this.setState({ lang: lang });
            window.location.reload();
        }
    }

    render() {
        return (
            <div className="header-topNav">
                <header className="header">
                    <Link to={(this.state.access_token) ? "/notification" : "/login"} className="notification-button">
                        {this.state.notify ?
                            <img className="bell-icon" src={images['bell-active-icon']} alt="" />
                            :
                            <img className="bell-icon" src={images['bell-icon']} alt="" />
                        }
                        <span id="notificationText">{strings["Announcement"]}</span>
                    </Link>

                    <img className="main-logo" src={images['Logo']} alt="" />

                    <a href={api.Helpline} className="helpline-button">
                        <img
                            className="helpline-icon"
                            src={images['helpline-icon']}
                            alt=""
                        />
                        <span id="helplineText">{strings["helplineText"]}</span>
                    </a>
                </header>
            </div>
        );
    }
}

export default Header;